/* eslint-disable prettier/prettier */
import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import styles from '../hiwTemplate.module.scss';

function HiwStepContent({
    title,
    description,
    isCurrent,
    onClick,
    onHover,
    onHoverExit,
    isPlaceholder = false,
    step }) {
  return <li
    className={`${styles.hiwTemplateStepContent} ${(!isCurrent && !isPlaceholder) && styles.hiwTemplateStepContentInactive} ${ isPlaceholder && styles.hiwTemplateStepContentPlaceholder}`}
  >
    <button
      className={styles.hiwTemplateStepContentButton}
      aria-label={`Go to step ${step + 1}`}
      onClick={onClick}
      onMouseEnter={onHover}
      onMouseLeave={onHoverExit}
      type="submit"
      data-testid={`hiw-step-content-${step}`.toString()}
      >
      <h3 className={styles.hiwTemplateStepContentTitle}>{title}</h3>
      <div className={ styles.hiwTemplateStepContentDescription }>{parse(description)}</div>
    </button>
  </li>
}

HiwStepContent.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  isCurrent: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  onHover: PropTypes.func,
  onHoverExit: PropTypes.func,
  step: PropTypes.number.isRequired,
  isPlaceholder: PropTypes.bool,
};

function HiwContents(props) {
  return <ul className={styles.hiwTemplateContents} {...props} />
}

export { HiwContents, HiwStepContent };
